// Vendor imports
const { combineReducers } = require('redux-immutable')
// Common imports
const commonReducers = require('client-v2/common/state/reducers')
// Sibling imports
const RootRecord = require('./record')

const reducers = Object.assign({}, commonReducers, {
  // Common container reducers
  articleProfileModal: require('client-v2/common/containers/article-profile/state/modal-reducer'),
  authModal: require('client-v2/common/containers/auth-modal/reducer'),
  // Entry container reducers
  feed: require('../containers/feed/reducer'),
  query: require('../containers/query/reducer')
})

module.exports = combineReducers(
  reducers,
  () => new RootRecord()
)
